/**
 * Middleware to handle navigation after successful user registration.
 *
 * This middleware prevents unauthorized access to the registration success page
 * by redirecting users to the home page if they haven't completed registration.
 *
 * @returns {void|NavigationFailure} Redirects to home page if registration is not successful
 * @example
 * // Automatically redirects to home if accessing registration success page without completing registration
 * export default defineNuxtRouteMiddleware((to) => { ... })
 */
export default defineNuxtRouteMiddleware(to => {
  const { registerSuccessful, homePath, getCanonicalUrl } = useRouteHelper()
  const storedValue = useCookie('successfulRegistered')
  if (
    (to.path === registerSuccessful || to.path === registerSuccessful + '/') &&
    storedValue.value !== 'successfulRegistered'
  ) {
    const path = getCanonicalUrl(homePath)
    return navigateTo(path)
  }
})
